var exports = {
  "x6": "DiscoveryButton.module__button___YUhQdF",
  "td": "DiscoveryButton.module__iconText___YUhQdF",
  "yF": "DiscoveryButton.module__iconTextSelected___YUhQdF",
};

module.exports = exports;
